/**
 * Search results page.
 *
 * Upgrades the filters and the more button so results update in place instead
 * of reloading the page. Everything here is an enhancement: without JavaScript
 * the filters are ordinary links and the more button is an ordinary paginated
 * link, and both still work.
 */
(function () {
    'use strict';

    var root = document.getElementById('search-results');

    if (!root || typeof tdwd_ajax === 'undefined') {
        return;
    }

    var grid = document.getElementById('search-grid');
    var count = document.getElementById('search-count');
    var more = document.getElementById('search-more');
    var filters = document.querySelectorAll('[data-search-filter]');
    var container = root.parentNode;

    var phrase = root.dataset.phrase || '';
    var filter = root.dataset.filter || 'all';
    var page = 1;
    var busy = false;

    /**
     * Request a page of results.
     *
     * @param {string}  nextFilter Filter key.
     * @param {number}  nextPage   1-based page number.
     * @param {boolean} append     Add to the grid rather than replace it.
     *
     * @return {Promise}
     */
    function request(nextFilter, nextPage, append) {
        var url = new URL(tdwd_ajax.ajaxurl, window.location.origin);

        url.searchParams.set('action', 'tdwd_search_results');
        url.searchParams.set('nonce', tdwd_ajax.search_nonce);
        url.searchParams.set('s', phrase);
        url.searchParams.set('type', nextFilter);
        url.searchParams.set('paged', String(nextPage));

        return fetch(url.toString(), { credentials: 'same-origin' })
            .then(function (response) {
                return response.json();
            })
            .then(function (payload) {
                if (!payload || !payload.success) {
                    throw new Error('failed');
                }

                render(payload.data, append);
            });
    }

    /**
     * Put a response on the page.
     *
     * @param {Object}  data   Response payload.
     * @param {boolean} append Add to the grid rather than replace it.
     */
    function render(data, append) {
        ensureGrid();

        if (append) {
            grid.insertAdjacentHTML('beforeend', data.html);
        } else {
            grid.innerHTML = data.html;
        }

        if (count) {
            count.textContent = data.total === 1
                ? tdwd_ajax.strings.oneResult
                : tdwd_ajax.strings.results.replace('%d', data.total);
        }

        if (data.counts) {
            Object.keys(data.counts).forEach(function (key) {
                var badge = document.querySelector('[data-count-for="' + key + '"]');
                var link = document.querySelector('[data-search-filter="' + key + '"]');

                if (badge) {
                    badge.textContent = data.counts[key];
                }

                if (link) {
                    link.classList.toggle(
                        'archive-page__filter--empty',
                        data.counts[key] === 0 && key !== filter
                    );
                }
            });
        }

        toggleMore(data.hasMore);
        toggleEmpty(data.total === 0);
    }

    /**
     * Make sure a grid exists to render into.
     *
     * The server sends an empty-state block instead of a grid when there are no
     * results, so switching to a filter that has some needs a grid built.
     */
    function ensureGrid() {
        if (grid && grid.isConnected) {
            return;
        }

        grid = document.createElement('div');
        grid.className = 'archive-page__grid';
        grid.id = 'search-grid';
        root.appendChild(grid);
    }

    function toggleEmpty(isEmpty) {
        var empty = document.getElementById('search-empty');

        if (isEmpty && !empty && grid) {
            grid.insertAdjacentHTML(
                'afterend',
                '<div class="archive-page__empty" id="search-empty"><p class="archive-page__empty-title">' +
                    tdwd_ajax.strings.noResults +
                    '</p></div>'
            );
        }

        if (!isEmpty && empty) {
            empty.remove();
        }

        if (grid) {
            grid.hidden = isEmpty;
        }
    }

    function toggleMore(hasMore) {
        if (!more) {
            return;
        }

        more.hidden = !hasMore;
    }

    function setBusy(value) {
        busy = value;
        root.setAttribute('aria-busy', value ? 'true' : 'false');
        root.classList.toggle('archive-page__results--busy', value);
    }

    /**
     * Switch filter without leaving the page.
     *
     * @param {string} nextFilter Filter key.
     * @param {string} url        URL to show in the address bar.
     * @param {boolean} push      Add a history entry.
     */
    function selectFilter(nextFilter, url, push) {
        if (busy) {
            return;
        }

        setBusy(true);
        filter = nextFilter;
        page = 1;
        root.dataset.filter = nextFilter;

        filters.forEach(function (link) {
            var active = link.dataset.searchFilter === nextFilter;

            link.classList.toggle('archive-page__filter--active', active);

            if (active) {
                link.setAttribute('aria-current', 'true');
            } else {
                link.removeAttribute('aria-current');
            }
        });

        if (push && window.history && window.history.pushState) {
            window.history.pushState({ filter: nextFilter }, '', url);
        }

        request(nextFilter, 1, false)
            .catch(function () {
                // Let the browser do it properly rather than leaving a dead page.
                window.location.href = url;
            })
            .finally(function () {
                setBusy(false);
            });
    }

    filters.forEach(function (link) {
        link.addEventListener('click', function (event) {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) {
                return;
            }

            event.preventDefault();
            selectFilter(link.dataset.searchFilter, link.href, true);
        });
    });

    var moreLink = document.querySelector('[data-search-more]');

    if (moreLink) {
        moreLink.addEventListener('click', function (event) {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) {
                return;
            }

            event.preventDefault();

            if (busy) {
                return;
            }

            setBusy(true);
            page += 1;

            request(filter, page, true)
                .catch(function () {
                    window.location.href = moreLink.href;
                })
                .finally(function () {
                    setBusy(false);
                });
        });
    }

    // Keep the back button working after filter changes.
    window.addEventListener('popstate', function () {
        var params = new URLSearchParams(window.location.search);

        selectFilter(params.get('type') || 'all', window.location.href, false);
    });

    if (container) {
        container.classList.add('archive-page__container--enhanced');
    }
})();
